import { time } from "@churchcenter/datetime-fmt"
import { bool, number, string, shape } from "prop-types"
import ScheduleItem from "source/myChurchCenter/Schedule/ScheduleItem"

UpcomingGroupsSharedEvent.propTypes = {
  id: number.isRequired,
  source: shape({
    app: string.isRequired,
    model_id: number.isRequired,
    params: shape({
      event_instance_id: number.isRequired,
    }),
  }),
  name: string.isRequired,
  starts_at: string.isRequired,
  ends_at: string.isRequired,
  is_all_day: bool.isRequired,
  day: number.isRequired,
  total_days: number.isRequired,
}

function activityTitle(name, startsAt, endsAt, isAllDay, day, totalDays) {
  const formattedStart = time(startsAt, { showTimeZone: false })
  const formattedEnd = time(endsAt, { showTimeZone: false })
  const formattedRange = time(startsAt, endsAt, { showTimeZone: false })
  const isMultiDay = totalDays > 1
  const isFirstDay = isMultiDay && day === 1
  const isLastDay = isMultiDay && day === totalDays

  let title
  if (isAllDay) {
    title = name + " (all day)"
  } else if (isFirstDay) {
    title = `${formattedStart} ${name}`
  } else if (isLastDay) {
    title = `${name} (until ${formattedEnd})`
  } else {
    title = `${formattedRange} ${name}`
  }

  return title
}
export default function UpcomingGroupsSharedEvent({
  name,
  source,
  starts_at,
  ends_at,
  is_all_day,
  day,
  total_days,
}) {
  const calendarEventPath = `/calendar/event/${source.params?.event_instance_id}`

  return (
    <ScheduleItem
      linkTitle={activityTitle(
        name,
        starts_at,
        ends_at,
        is_all_day,
        day,
        total_days,
      )}
      linkUrl={calendarEventPath}
      itemDescription={<div className="badge">Shared event</div>}
    />
  )
}
